import LeaveRequestTaskList from "./pages/ListPage.vue";
import LeaveRequestTaskDetail from "./pages/FormPage.vue";
import LeaveRequestTaskIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/leave_request_task",
    component: LeaveRequestTaskIndex,
    redirect: "/leave_request_task/list",
    name: "leave_request_task",
    children: [
      {
        path: "list",
        component: LeaveRequestTaskList,
        name: "leave_request_task.list",
      },
      {
        path: "create",
        component: LeaveRequestTaskDetail,
        name: "leave_request_task.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: LeaveRequestTaskDetail,
        name: "leave_request_task.edit",
        props: { create: false },
      },
    ],
  },
];
